import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./Home";
import Refresh from "./Refresh";
import Return from "./Return";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Dashboard from "./Dashboard";
import RestaurantSetup from "./pages/RestaurantSetup";
import MenuManagement from "./pages/MenuManagement";
import OrdersDashboard from "./pages/OrdersDashboard";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import QRCodeGenerator from "./components/qr/QRCodeGenerator";
import MenuPage from "./pages/MenuPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PasswordReset from "./components/Auth/PasswordReset";
import ResetPasswordConfirm from "./components/Auth/ResetPasswordConfirm";
import ProtectedRoute from "./components/ProtectedRoute";
import TermsOfService from './pages/TermsOfService';
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/restaurant/new"
                element={
                  <ProtectedRoute>
                    <RestaurantSetup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/restaurant/:restaurantId/menu"
                element={
                  <ProtectedRoute>
                    <MenuManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/restaurant/:restaurantId/orders"
                element={
                  <ProtectedRoute>
                    <OrdersDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/restaurant/:restaurantId/qr"
                element={
                  <ProtectedRoute>
                    <QRCodeGenerator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/restaurant/:restaurantId/analytics"
                element={
                  <ProtectedRoute>
                    <AnalyticsDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/refresh/:connectedAccountId"
                element={
                  <ProtectedRoute>
                    <Refresh />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/return/:connectedAccountId"
                element={
                  <ProtectedRoute>
                    <Return />
                  </ProtectedRoute>
                }
              />
              <Route path="/password-reset" element={<PasswordReset />} />
              <Route
                path="/reset-password-confirm"
                element={<ResetPasswordConfirm />}
              />
              {/* Add the Terms of Service route */}
              <Route path="/terms" element={<TermsOfService />} />
              
              {/* Public routes - no authentication required */}
              <Route path="/menu/:restaurantId" element={<MenuPage />} />
              <Route path="/cart/:restaurantId" element={<CartPage />} />
              <Route path="/checkout/:orderId" element={<CheckoutPage />} />
              <Route
                path="/payment-success/:orderId"
                element={<PaymentSuccessPage />}
              />
              
              {/* 404 catch-all route */}
              <Route
                path="*"
                element={
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    <h1>404 - Page Not Found</h1>
                    <p>The page you're looking for doesn't exist.</p>
                    <button onClick={() => (window.location.href = "/")}>
                      Return to Home
                    </button>
                  </div>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;